import { render, staticRenderFns } from "./InactivityTimer.vue?vue&type=template&id=64dd1057&scoped=true"
import script from "./InactivityTimer.vue?vue&type=script&lang=js"
export * from "./InactivityTimer.vue?vue&type=script&lang=js"
import style0 from "./InactivityTimer.vue?vue&type=style&index=0&id=64dd1057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd1057",
  null
  
)

export default component.exports